/**
 * project模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const project = {
  // 创建project
  createProject(params) {
    return $http.post(`${global.API_URL}/sme/project/create`,params);
  },
  //查询projectList
  selectList(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/project/selectList`,param);
  },
  //根据id查project
  selectProject(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/project/select`,param);
  },
  //根据项目名查询project
  selectByName(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/project/selectByName`,param);
  },
  // 下载Excel文件
  exportProject(params) {
    return $http.post(`${global.API_URL}/sme/project/export`,params,{responseType: 'arraybuffer'});
  },
  // 更新project
  updateProject(params) {
    return $http.post(`${global.API_URL}/sme/project/update`,params);
  }
}

export default project;



// WEBPACK FOOTER //
// ./src/api/project.js